/**
 * Customer, third-party integration and third-party names, as the API validates them on create and update:
 * `ModelValidation.OrganizationNameRegEx` = `^[a-zA-Z0-9._ -]{1,50}$` (INN-SecurityManager `Constants/ModelValidation.cs`).
 */
export const ORGANIZATION_NAME_MAX_LENGTH = 50;

/** The API's allowed characters. Length is checked separately, so the counter and maxlength carry it. */
export const ORGANIZATION_NAME_PATTERN = /^[a-zA-Z0-9._ -]*$/;

export const ORGANIZATION_NAME_PATTERN_MESSAGE = 'Use letters, numbers, spaces, dots, dashes and underscores only.';

/** True when the API will accept the name. */
export function isValidOrganizationName(name: string): boolean {
  const trimmed = name.trim();
  return trimmed.length > 0 && name.length <= ORGANIZATION_NAME_MAX_LENGTH && ORGANIZATION_NAME_PATTERN.test(name);
}
